import axios from 'axios'

// 默认超时20s
axios.defaults.timeout = 1000 * 20

// request
axios.interceptors.request.use(config => {
    // console.log(config)
    return config
}, (error) => {
    return Promise.reject(error)
})

// response
axios.interceptors.response.use(res => {
    // console.log(res)
    if (!res) return Promise.reject(res)
    return res
}, (error) => {
    return Promise.reject(error)
})

export default axios


